// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили */
.crypto-subtitle {
  display: grid;
  font-size: 2vw;
  place-self: center;
}
.crypto-buttonCheck {
  display: flex;
  gap: 0.5vw;
  padding: 0.4vw 0.75vw;
  justify-content: space-evenly;
  border-radius: 0.9vw;
  width: max-content;
  height: 3vw;
  cursor: pointer;
  color: white;
  place-self: center;
  font-size: 1.8vw;
  white-space: nowrap;
  background-color: #1a6a7c;
}
.crypto-logoRun {
  height: 2.1vw;
  place-self: center;
}

.crypto-Scene {
  display: flex;
  flex-direction: column;
  gap: 1vw;
}

.crypto-board-content {
  display: grid;
  grid-template-columns: auto 70%;
}
/* Логотип с кнопками и таймером */

.crypto-board-logo {
  display: grid;
  grid-template-rows: 24vw 3vw 3vw;
  gap: 1vw;
  width: inherit;
  place-content: end;
}

.crypto-board-logo-image {
  position: relative;
  height: 24vw;
  left: 2.5vw;
}

#crypto-button-board-logo {
  position: relative;
  left: 1.4vw;
}

#crypto-subtitle-board-logo {
  position: relative;
  left: 1.3vw;
}
/* Игровое поле */
.crypto-board-game {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1vw;
}
/* Кодовое слово */
.crypto-board-game-code-word {
  display: grid;
  --cell-size: 5vw;
  height: var(--cell-size);

  border: 0.1vw solid;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);

  background-color: white;
}
.crypto-code-cell {
  height: 4vw;
  width: 4vw;
  place-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* Магический квадрат */
.crypto-board-game-key-wrapper {
  position: relative;

  width: 24vw;
  height: 24vw;

  border: 0.15vw solid;
  background-color: white;
  perspective: 1000px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}

.crypto-board-game-key-word {
  width: 20vw;
  height: 20vw;

  display: grid;
  grid-template-rows: repeat(3, 1fr);

  background-image:
    linear-gradient(
      to right,
      transparent calc(33.333% - 0.1vw),
      #000 calc(33.333% - 0.1vw),
      #000 calc(33.333% + 0.1vw),
      transparent calc(33.333% + 0.1vw),
      transparent calc(66.666% - 0.1vw),
      #000 calc(66.666% - 0.1vw),
      #000 calc(66.666% + 0.1vw),
      transparent calc(66.666% + 0.1vw)
    ),
    linear-gradient(
      to bottom,
      transparent calc(33.333% - 0.1vw),
      #000 calc(33.333% - 0.1vw),
      #000 calc(33.333% + 0.1vw),
      transparent calc(33.333% + 0.1vw),
      transparent calc(66.666% - 0.1vw),
      #000 calc(66.666% - 0.1vw),
      #000 calc(66.666% + 0.1vw),
      transparent calc(66.666% + 0.1vw)
    );
}

.crypto-board-game-key-row {
  display: grid;
  place-items: center;
  font-size: 4vw;
  grid-template-columns: repeat(3, 1fr);
}

.crypto-win-image {
  width: 25.7vw;
  height: 25.7vw;
  animation: winAppearCrypto 1.5s ease forwards;
}

.crypto-card{
    position:relative;
    width:100%;
    height:100%;
    transition:transform 2s;
    transform-style:preserve-3d;
}

.crypto-card-flipped{
    transform:rotateY(180deg);
}

.crypto-card-face{
    position:absolute;
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    backface-visibility:hidden;
}

.crypto-card-back{
    transform:rotateY(180deg);
}
/* Поле для ввода */
.crypto-board-input {
  display: grid;
  grid-template-columns: auto auto 8vw;
  gap: 1vw;
}
.crypto-board-input-field {
  background: white;
  border: 0.1vw solid;
  height: 3vw;
  text-transform: uppercase;
  border-radius: 0.9vw;
  font-size: 2vw;
  padding: 0.6vw;
}

.crypto-input-error {
  background-color: #ffcccc;
}
/* Символы */
.crypto-symbol {
  width: 85%;
  height: 85%;
  box-sizing: border-box;
}
.symbol-0 {
  border-bottom: 0.25vw solid black;
  border-right: 0.25vw solid black;
}

.symbol-1 {
  border-bottom: 0.25vw solid black;
  border-left: 0.25vw solid black;
  border-right: 0.25vw solid black;
}

.symbol-2 {
  border-left: 0.25vw solid black;
  border-bottom: 0.25vw solid black;
}

.symbol-3 {
  border-top: 0.25vw solid black;
  border-bottom: 0.25vw solid black;
  border-right: 0.25vw solid black;
}

.symbol-4 {
  border: 0.25vw solid black;
}

.symbol-5 {
  border-left: 0.25vw solid black;
  border-top: 0.25vw solid black;
  border-bottom: 0.25vw solid black;
}

.symbol-6 {
  border-top: 0.25vw solid black;
  border-right: 0.25vw solid black;
}

.symbol-7 {
  border-top: 0.25vw solid black;
  border-left: 0.25vw solid black;
  border-right: 0.25vw solid black;
}

.symbol-8 {
  border-top: 0.25vw solid black;
  border-left: 0.25vw solid black;
}

@keyframes winAppearCrypto {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Сrypto/styles/CryptoBoard.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;AACA,kCAAkC;;AAElC;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;AACV;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;;EAExB,mBAAmB;EACnB;;mCAEiC;;EAEjC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,uBAAuB;AACvB;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB;;mCAEiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,kCAAkC;;EAElC;;;;;;;;;;;;;;;;;;;;;;KAsBG;AACL;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,6CAA6C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA,YAAY;AACZ;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/* Общие стили */\n.crypto-subtitle {\n  display: grid;\n  font-size: 2vw;\n  place-self: center;\n}\n.crypto-buttonCheck {\n  display: flex;\n  gap: 0.5vw;\n  padding: 0.4vw 0.75vw;\n  justify-content: space-evenly;\n  border-radius: 0.9vw;\n  width: max-content;\n  height: 3vw;\n  cursor: pointer;\n  color: white;\n  place-self: center;\n  font-size: 1.8vw;\n  white-space: nowrap;\n  background-color: #1a6a7c;\n}\n.crypto-logoRun {\n  height: 2.1vw;\n  place-self: center;\n}\n\n.crypto-Scene {\n  display: flex;\n  flex-direction: column;\n  gap: 1vw;\n}\n\n.crypto-board-content {\n  display: grid;\n  grid-template-columns: auto 70%;\n}\n/* Логотип с кнопками и таймером */\n\n.crypto-board-logo {\n  display: grid;\n  grid-template-rows: 24vw 3vw 3vw;\n  gap: 1vw;\n  width: inherit;\n  place-content: end;\n}\n\n.crypto-board-logo-image {\n  position: relative;\n  height: 24vw;\n  left: 2.5vw;\n}\n\n#crypto-button-board-logo {\n  position: relative;\n  left: 1.4vw;\n}\n\n#crypto-subtitle-board-logo {\n  position: relative;\n  left: 1.3vw;\n}\n/* Игровое поле */\n.crypto-board-game {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 1vw;\n}\n/* Кодовое слово */\n.crypto-board-game-code-word {\n  display: grid;\n  --cell-size: 5vw;\n  height: var(--cell-size);\n\n  border: 0.1vw solid;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n\n  background-color: white;\n}\n.crypto-code-cell {\n  height: 4vw;\n  width: 4vw;\n  place-self: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* Магический квадрат */\n.crypto-board-game-key-wrapper {\n  position: relative;\n\n  width: 24vw;\n  height: 24vw;\n\n  border: 0.15vw solid;\n  background-color: white;\n  perspective: 1000px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}\n\n.crypto-board-game-key-word {\n  width: 20vw;\n  height: 20vw;\n\n  display: grid;\n  grid-template-rows: repeat(3, 1fr);\n\n  background-image:\n    linear-gradient(\n      to right,\n      transparent calc(33.333% - 0.1vw),\n      #000 calc(33.333% - 0.1vw),\n      #000 calc(33.333% + 0.1vw),\n      transparent calc(33.333% + 0.1vw),\n      transparent calc(66.666% - 0.1vw),\n      #000 calc(66.666% - 0.1vw),\n      #000 calc(66.666% + 0.1vw),\n      transparent calc(66.666% + 0.1vw)\n    ),\n    linear-gradient(\n      to bottom,\n      transparent calc(33.333% - 0.1vw),\n      #000 calc(33.333% - 0.1vw),\n      #000 calc(33.333% + 0.1vw),\n      transparent calc(33.333% + 0.1vw),\n      transparent calc(66.666% - 0.1vw),\n      #000 calc(66.666% - 0.1vw),\n      #000 calc(66.666% + 0.1vw),\n      transparent calc(66.666% + 0.1vw)\n    );\n}\n\n.crypto-board-game-key-row {\n  display: grid;\n  place-items: center;\n  font-size: 4vw;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.crypto-win-image {\n  width: 25.7vw;\n  height: 25.7vw;\n  animation: winAppearCrypto 1.5s ease forwards;\n}\n\n.crypto-card{\n    position:relative;\n    width:100%;\n    height:100%;\n    transition:transform 2s;\n    transform-style:preserve-3d;\n}\n\n.crypto-card-flipped{\n    transform:rotateY(180deg);\n}\n\n.crypto-card-face{\n    position:absolute;\n    width:100%;\n    height:100%;\n    display:flex;\n    justify-content:center;\n    align-items:center;\n    backface-visibility:hidden;\n}\n\n.crypto-card-back{\n    transform:rotateY(180deg);\n}\n/* Поле для ввода */\n.crypto-board-input {\n  display: grid;\n  grid-template-columns: auto auto 8vw;\n  gap: 1vw;\n}\n.crypto-board-input-field {\n  background: white;\n  border: 0.1vw solid;\n  height: 3vw;\n  text-transform: uppercase;\n  border-radius: 0.9vw;\n  font-size: 2vw;\n  padding: 0.6vw;\n}\n\n.crypto-input-error {\n  background-color: #ffcccc;\n}\n/* Символы */\n.crypto-symbol {\n  width: 85%;\n  height: 85%;\n  box-sizing: border-box;\n}\n.symbol-0 {\n  border-bottom: 0.25vw solid black;\n  border-right: 0.25vw solid black;\n}\n\n.symbol-1 {\n  border-bottom: 0.25vw solid black;\n  border-left: 0.25vw solid black;\n  border-right: 0.25vw solid black;\n}\n\n.symbol-2 {\n  border-left: 0.25vw solid black;\n  border-bottom: 0.25vw solid black;\n}\n\n.symbol-3 {\n  border-top: 0.25vw solid black;\n  border-bottom: 0.25vw solid black;\n  border-right: 0.25vw solid black;\n}\n\n.symbol-4 {\n  border: 0.25vw solid black;\n}\n\n.symbol-5 {\n  border-left: 0.25vw solid black;\n  border-top: 0.25vw solid black;\n  border-bottom: 0.25vw solid black;\n}\n\n.symbol-6 {\n  border-top: 0.25vw solid black;\n  border-right: 0.25vw solid black;\n}\n\n.symbol-7 {\n  border-top: 0.25vw solid black;\n  border-left: 0.25vw solid black;\n  border-right: 0.25vw solid black;\n}\n\n.symbol-8 {\n  border-top: 0.25vw solid black;\n  border-left: 0.25vw solid black;\n}\n\n@keyframes winAppearCrypto {\n  from {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
